import React from "react";
import {
  Divider,
  Form,
  Input,
  Button,
  Checkbox,
  Select,
  InputNumber,
  message,
} from "antd";

import { setPensando, setStoreWidgets, store } from "../../../../store";
import { Api } from "../../../../api/configApi";
import { ObjectId } from "bson";
import CamposPersonalizados from "./CamposPersonalizados";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import Boton from "../../../../components/design/elementos/boton";

function CrearActualizarWidgetPasarelas(props) {
  const { Option } = Select;
  const [loading, setLoading] = React.useState(false);
  const [insertOrUpdate, setInsertOrUpdate] = React.useState("InsertWidgets");
  const [formularioGuardado, setFormularioGuardado] = React.useState(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    values.tipo = "pasarelas";
    setPensando(true);
    setLoading(true);
    Api("Cuentas", insertOrUpdate, { _id: store.cuentaactiva }, values)
      .then((res) => {
        setLoading(false);
        setFormularioGuardado(!formularioGuardado);
        setPensando(false);
        setLoading(false);
        return Api(
          "Cuentas",
          "Get",
          { _id: store.cuentaactiva },
          { widgets: 1 }
        );
      })
      .then((res) => {
        props.setVisible(false);
        setStoreWidgets(res[0].widgets);
      })
      .catch((err) => {
        setPensando(false);
        setLoading(false);
      });
  };
  React.useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ _id: new ObjectId() });
  }, [props.visible]);
  React.useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
      setInsertOrUpdate("UpdateWidgets");
    } else {
      form.setFieldsValue({ _id: new ObjectId() });
    }
  }, [props.data]);
  return (
    <div>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Nombre"
          name="nombre"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un nombre" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="_id" hidden rules={[{ required: true }]}></Form.Item>

        <Form.Item
          label="Titulo"
          name="titulo"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un titulo" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Descripción"
          name="descripcion"
          hasFeedback
          rules={[{ required: true, message: "Ingresa una descripción" }]}
        >
          <Input />
        </Form.Item>

        <CamposPersonalizados
          formularioGuardado={formularioGuardado}
          formulario={form}
        />

        <Form.List name="condicionales">
          {(fields, { add, remove }) => (
            <div
              style={{
                background: "rgb(237 237 237)",
                minHeight: 100,
                padding: 10,
                borderRadius: 5,
              }}
            >
              {fields.map(({ key, name, fieldKey, ...restField }, index2) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Form.Item
                    style={{ flex: 1, margin: 5 }}
                    hasFeedback
                    {...restField}
                    colon={false}
                    name={[name, "atributo"]}
                    fieldKey={[fieldKey, "atributo"]}
                    rules={[
                      {
                        required: true,
                        message: "Campo obligatorio",
                      },
                    ]}
                    label="Atributo"
                  >
                    <Select>
                      {store.losatributos.texts.map((atr) => {
                        return <Option value={atr.nombre}>{atr.nombre}</Option>;
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    style={{ flex: 1, margin: 5 }}
                    hasFeedback
                    {...restField}
                    colon={false}
                    name={[name, "operador"]}
                    fieldKey={[fieldKey, "operador"]}
                    rules={[
                      {
                        required: true,
                        message: "Campo obligatorio",
                      },
                    ]}
                    label="operador"
                  >
                    <Select>
                      <Option value="$eq">Es Igual</Option>
                      <Option value="$ne">Es diferente</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item style={{ flex: 1, margin: 5 }} shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        getFieldValue().condicionales[index2] && (
                          <Form.Item
                            {...restField}
                            name={[name, "valor"]}
                            fieldKey={[fieldKey, "valor"]}
                            label="Valor"
                            style={{
                              flex: 1,
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Campo obligatorio",
                              },
                            ]}
                          >
                            <Select>
                              {store.losatributos.texts
                                .find((at) => {
                                  return (
                                    at.nombre ===
                                    getFieldValue().condicionales[index2]
                                      .atributo
                                  );
                                })
                                .opciones.map((op, index) => {
                                  return (
                                    <Option key={"i" + index} value={op}>
                                      {op}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        )
                      );
                    }}
                  </Form.Item>
                  <FontAwesomeIcon
                    style={{
                      cursor: "pointer",
                      alignSelf: "center",
                      marginTop: 27,
                      marginLeft: 10,
                    }}
                    icon={faMinusCircle}
                    onClick={() => remove(name)}
                  />
                </div>
              ))}

              <p
                style={{
                  fontSize: 13,
                  marginBottom: 30,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                onClick={() => {
                  store.losatributos.texts.length > 0
                    ? add()
                    : message.error(
                        "Debe tener atributos TEXTO para crear condicionales"
                      );
                }}
              >
                + Agregar Condicional
              </p>
            </div>
          )}
        </Form.List>

        <Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 15,
            }}
          >
            <Boton loading={loading} texto="Guardar" htmlType="submit" />
            <Boton
              loading={loading}
              onClick={() => {
                props.setVisible(false);
              }}
              texto="Cancelar"
              tipo="danger"
              htmlType="button"
            />
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default CrearActualizarWidgetPasarelas;
